<template>
  <div class="modal" v-bind:class="{ 'is-active': show }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Cambiar Carpeta de Informe</p>
        <button class="delete" aria-label="close" @click="closemodal(false)"></button>
      </header>
      <section class="modal-card-body">
        <div class="field has-addons">
          <div class="control is-expanded">
            <input v-model="nombreCarpeta" class="input" type="text" placeholder="Crear Carpeta"/>
          </div>
          <div class="control">
            <a @click="guardarcarpeta" class="button is-info">Aceptar</a>
          </div>
        </div>
        <div class="field is-grouped">
          <div class="control">
            <div class="select">
              <select v-model="carpetaSelected">
                <option
                    v-for="(option, index) in carpetas"
                    v-bind:value="option"
                    v-bind:key="index"
                    :disabled='option.nombre === "Seleccionar Carpeta"'
                >{{ option.nombre }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-success" @click="estoyseguro">Estoy seguro</button>
        <button class="button" @click="closemodal(false)">Cancelar</button>
      </footer>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";

export default {
  data() {
    return {
      nombreCarpeta:"",
      carpetas: [{nombre: "Seleccionar Carpeta"}],
      carpetaSelected: {nombre: "Seleccionar Carpeta"},
    };
  },
  props:{
    show:{
      type: Boolean
    },
    folder:{
      type: String
    },
    inf:{
      type: Object
    }
  },
  methods: {
    guardarcarpeta() {
      if (this.nombreCarpeta) {
        this.creaCarpetas(this);
      }
    },
    closemodal(save) {
      this.$emit('showInfoFolder', {}, save)
    },
    async estoyseguro() {
      let result
      let data = { carpeta: this.carpetaSelected, id: this.inf.id }
      try {
        if (data.carpeta.nombre !== "Seleccionar Carpeta"){
          result = await apiServices.post(`/editcarpetainforme`, data);
          if (result){
            await this.$emit('traeData')
            this.closemodal(true)
          }
        }else {
          this.$store.dispatch("notify", {
            message: `Porfavor escoge una carpeta`,
            type: "is-danger",
          });
        }
      }catch (err){
        console.log(err)
      }
    },
    async creaCarpetas(_this) {
      const data = {
        nombre: this.nombreCarpeta,
      };
      let result;
      try {
        result = await apiServices.post(`/createcarpeta`, data);

        if (result){
          this.carpetas.push(result.data);
          this.nombreCarpeta = "";
          await this.traeCarpetas()
          await this.$emit('traeData')

          this.$store.dispatch("notify", {
            message: `Carpeta creada ahora elígela`,
          });
        }

      } catch (err) {
        console.log(err);
      }
    },
    async traeCarpetas() {
      let result;
      let _this = this
      try {
        result = await apiServices.get(`/carpetas`);
        _this.carpetas = [{nombre: "Seleccionar Carpeta"}]
        result.data.forEach(function (k, v) {
          if (k.nombre !== "DEFAULTSINCLASIFICARSIETE") {
            _this.carpetas.push(k);
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.traeCarpetas()
  },
  watch:{
    inf(nv){
      if (nv){
        this.traeCarpetas()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.icon-lista {
  vertical-align: bottom;
}

.panel {
  border-left: 1px solid #e1e1e1;
}

.buttons {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/changeFolder.vue